export class StaffCard {
  id: number;
  fullName: string
  roomIds: number[];
  codeId: string;

  constructor() {
    this.id = 0;
    this.fullName = '';
    this.roomIds = [];
    this.codeId = null;
  }
}